import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import SettingSidebar from '@/features/Setting/settings-sidebar/SettingSidebar';

const SettingLayout = () => {
  return (
    <Style>
      <div className="setting-sidebar-area">
        <SettingSidebar />
      </div>
      <div className="setting-body-area">
        <div className="setting-content-area">
          <Outlet />
        </div>
      </div>
    </Style>
  );
};

const Style = styled(Flex)`
  position: relative;
  height: 100%;
  .setting-body-area {
    width: calc(100% - 220px);
    height: 100%;
    background-color: ${(props) => props.theme.colors.gray250};
    .setting-content-area {
      width: 100%;
      height: 100%;
      background-color: ${(props) => props.theme.colors.gray100};
      box-shadow: 4px 0px 16px ${(props) => props.theme.colors.FD08};
    }
  }

  .setting-sidebar-area {
    position: relative;
    width: 220px;
    height: 100%;
    z-index: 3;
    border-right: 1px solid ${(props) => props.theme.colors.gray250};
    background-color: ${(props) => props.theme.colors.gray100};
  }
`;

export default SettingLayout;
